import en from "./en";
const zh = {
  ...en,
  nav: {
    home: "首页",
    about: "联盟介绍",
    markets: "覆盖市场",
    services: "服务",
    partners: "合作伙伴",
    manufacturers: "面向制造商",
    news: "新闻",
    contact: "联系我们",
    partner_cta: "成为合作伙伴",
  },
  hero: {
    eyebrow: "欧洲电动出行联盟",
    title_line1: "欧洲电动出行的",
    title_line2: "分销平台",
    subtitle: "连接制造商与欧洲最具经验的分销网络。我们不仅进口车辆,我们打造品牌。",
    cta_primary: "成为合作伙伴",
    cta_secondary: "探索联盟",
    scroll: "向下滚动了解更多",
  },
  cta_final: {
    eyebrow: "战略合作",
    title: "准备好在欧洲拓展业务了吗?",
    subtitle: "与 EEMA 合作,借助覆盖欧洲最具战略意义的电动出行市场的成熟商业平台,快速进入欧洲。",
    button: "预约会面",
  },
};
export default zh;
